<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12>
   			<v-card>
	   			<v-card-title>

            <v-text-field v-model="filter.code" label="Return ID" class="mr-3"></v-text-field>
            
            <v-autocomplete v-model="filter.status" :items="statuses" item-text="title" item-value="id" label="Status" class="mr-3"></v-autocomplete>

            <v-autocomplete v-if="filter.type !== config.invoiceTypes.franchisee" :loading="franchiseeLoading" v-model="filter.retailer" :search-input.sync="franchiseeSearchText" :items="franchisees" item-text="title" item-value="id" label="Branch Name" hide-no-data class="mr-3" clearable>
              <template slot="item" slot-scope="data">
                <v-list-tile-content>
                  <v-list-tile-title v-text="data.item.title"></v-list-tile-title>
                  <v-list-tile-sub-title class="caption" v-text="data.item.mobile"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>
            
            <v-autocomplete v-model="filter.type" :items="types" item-text="title" item-value="id" label="Type" class="mr-3"></v-autocomplete>

            <v-autocomplete v-if="filter.type == config.invoiceTypes.customer" :loading="customerLoading" v-model="filter.customer" :search-input.sync="customerSearchMobile" :items="customers" item-text="mobile" item-value="id" label="Customer Mobile" hide-no-data class="mr-3">
              <template slot="item" slot-scope="data">
                <v-list-tile-content>
                  <v-list-tile-title v-text="data.item.title"></v-list-tile-title>
                  <v-list-tile-sub-title class="caption" v-text="data.item.mobile"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>

            <v-autocomplete v-if="filter.type == config.invoiceTypes.customer" :loading="customerLoading" v-model="filter.customer" :search-input.sync="customerSearchText" :items="customers" item-text="title" item-value="id" label="Customer Name" hide-no-data class="mr-3">
              <template slot="item" slot-scope="data">
                <v-list-tile-content>
                  <v-list-tile-title v-text="data.item.title"></v-list-tile-title>
                  <v-list-tile-sub-title class="caption" v-text="data.item.mobile"></v-list-tile-sub-title>
                </v-list-tile-content>
              </template>
            </v-autocomplete>

            <v-autocomplete v-if="filter.type == config.invoiceTypes.franchisee" :loading="franchiseeLoading" v-model="filter.franchisee" :search-input.sync="franchiseeSearchText" :items="franchisees" item-text="title" item-value="id" label="Franchisee Name" hide-no-data>
            </v-autocomplete>

            <search-btn @click="filterData" />

            <v-spacer></v-spacer>

            <v-btn v-if="hasCreateAccess" to="/sales-return" round color="primary" dark small class="ml-4">Add New</v-btn>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="items"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
              <tr is="sales-return-list-item" :item="props.item" @confirm="openConfirmDialog" @cancel="confirmCancelItem"></tr>
				    </template>
				    <template slot="no-data" v-if="!processing && !items.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <v-pagination @loadPage="loadPage" />

			</v-card>
   		</v-flex>

      <action-dialog action="cancel" :status="cancelDialog" @close="closeCancelDialog" @success="cancelSalesReturn" />
      <action-dialog action="confirm" :status="confirmDialog" @close="closeConfirmDialog" @success="confirmSalesReturn" />

   	</v-layout>
    
  </v-flex>
</template>

<script>

  import SalesReturnListItem from './SalesReturnListItem'

  export default {
    name: 'SalesReturnList',
    data () {
      return {
      	title: "Sales Return List",
      	processing: false,
      	items: [],
        headers: [
          { text: 'Return ID', value: 'code'},
          { text: 'Sale ID', value: 'invoice_code'},
          { text: 'Return Date', value: 'added_time'},
          { text: 'Customer/Franchisee', value: 'customer_name', sortable: false},
          { text: 'Branch', value: 'retailer_name'},
          // { text: 'Sub Total (Rs.)', value: 'total', align: 'right'},
          // { text: 'Discount (Rs.)', value: 'discount', align: 'right'},
          // { text: 'GST (Rs.)', value: 'tax', align: 'right'},
          { text: 'Total (Rs.)', value: 'grandtotal', align: 'right'},
          { text: 'Status', value: 'status', align: 'center', sortable: false },
          { text: 'Actions', value: 'id', sortable: false }
        ],
        cancellingItem: null,
        cancelDialog: false,
        confirmingItem: null,
        confirmDialog: false,
        filter: {
          type: "",
          code: "",
          customer: "",
          franchisee: "",
          retailer: "",
          confirmed: true,
          status: ""
        },
        types: [
          {
            id: "",
            title: "All"
          }
        ],
        statuses: [
          {
            id: "",
            title: "All"
          }
        ],
        customerLoading: false,
        customerSearchText: "",
        customerSearchMobile: "",
        customers: [],
        franchiseeLoading: false,
        franchiseeSearchText: "",
        franchisees: []
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Sales Return',
	          disabled: true
	        },
	        {
	          text: 'List',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Sales Return')
    },
    methods: {

      loadPage () {

        let api_path = this.config.apis.getSalesReturns.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage)
          
        let filterArray = []

        for (const [key, val] of Object.entries(this.filter)) {
          if (val || val === 0) {
            filterArray.push(`${key}=${val}`)
          }
        }

        if (filterArray.length) {
          api_path += '?' + filterArray.join('&')
        }
        
        this.processing = true
        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
            	this.items = response.data.data.items
              this.$store.commit('setItemsCount', response.data.data.total)
            }
            else{
            	this.items = []
              this.$store.commit('setItemsCount', 0)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      searchCustomers (params) {
        
        let api_path = this.config.apis.getCustomers.replace(":page", 1).replace(":perPage", this.paginationOptions.rowsPerPage)

        api_path += params

        this.customerLoading = true
        this.axios.get(api_path)
        .then((response) => {
            this.customerLoading = false
            if (this.isSuccessResponse(response)) {
              this.customers = response.data.data.items
            }
        })
        .catch((error) => {
            this.customerLoading = false
        })

      },

      searchCustomersByName () {

        let param = `?title=${this.customerSearchText}`

        this.searchCustomers(param)

      },

      searchCustomersByMobile () {

        let param = `?mobile=${this.customerSearchMobile}`

        this.searchCustomers(param)
      },

      searchFranchisees () {
        this.franchiseeLoading = true
        this.axios.get(`${this.config.apis.searchRetailers}?title=${this.franchiseeSearchText}`)
        .then((response) => {
            this.franchiseeLoading = false
            if (this.isSuccessResponse(response)) {
              this.franchisees = response.data.data
            }
        })
        .catch((error) => {
            this.franchiseeLoading = false
        })
      },

      confirmCancelItem (item) {
        this.cancellingItem = item
        this.cancelDialog = true
      },

      closeCancelDialog () {
        this.cancellingItem = null
        this.cancelDialog = false
      },

      cancelSalesReturn () {
        
        if (!this.cancellingItem) return

        this.processing = true
        this.axios.put(this.config.apis.cancelSalesReturn.replace(":id", this.cancellingItem.id))
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.cancellingItem.status = this.config.saleReturnStatus.cancelled

              this.notifySuccess('updateSuccess')
              this.closeCancelDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.closeCancelDialog()
          })
      },

      openConfirmDialog (item) {
        this.confirmingItem = item
        this.confirmDialog = true
      },

      closeConfirmDialog () {
        this.confirmingItem = null
        this.confirmDialog = false
      },

      confirmSalesReturn () {
        
        if (!this.confirmingItem) return

        this.processing = true
        this.axios.put(this.config.apis.confirmSalesReturn.replace(":id", this.confirmingItem.id))
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.confirmingItem.status = this.config.saleReturnStatus.confirmed

              this.notifySuccess('updateSuccess')
              this.closeConfirmDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
            this.closeConfirmDialog()
          })
      }

    },
    mounted () {
      
      for (const [key, val] of Object.entries(this.config.invoiceTypes)) {
        this.types.push({id: val, title: key})
      }

      for (const [key, val] of Object.entries(this.config.saleReturnStatus)) {
        this.statuses.push({id: val, title: key})
      }
      
    },

    computed: {

    },

    watch: {

      customerSearchText (val, oldVal) {
        if (val && val != oldVal) {
          this.searchCustomersByName()
        }
      },

      customerSearchMobile (val, oldVal) {
        if (val && val != oldVal) {
          this.searchCustomersByMobile()
        }
      },

      franchiseeSearchText (val, oldVal) {
        if (val && val != oldVal) {
          this.searchFranchisees()
        }
      },

      'filter.type' (val) {
        
        this.filter.franchisee = ""
        this.filter.customer = ""

        if (val === this.config.invoiceTypes.franchisee) {
          this.filter.retailer = ""
        }
      },

      'filter.retailer' (val) {

        if (!val) {
          this.filter.retailer = ""
        }
      }

    },
    
    components: {
      'sales-return-list-item': SalesReturnListItem
    }

  }
</script>
